import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { emailVerification } from "../reducer/Actions";

const EmailVerification = ({ emailVerification }) => {
    const [status, setStatus] = useState(null); // null represents initial state
    const { key } = useParams();

    useEffect(() => {
        // Trigger email verification when the component mounts
        emailVerification(key)
            .then(() => setStatus(true)) // Email verification succeeded
            .catch(() => setStatus(false)); // Email verification failed
    }, [emailVerification, key]); // Dependency array includes emailVerification and key

    if (status === true) {
        return <Navigate to={"../login/"}></Navigate>
    } else if (status === false) {
        return <p>Failed to verify email. Something went wrong.</p>;
    }

    // If status is null (initial state), render nothing until verification completes
    return null;
};

export default connect(null, { emailVerification })(EmailVerification);
